class aclHelper {
    async checkValidFileUpload(files) {
        const getFileSignature = (file) => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                const blob = file.slice(0, 20);
                reader.readAsArrayBuffer(blob);

                reader.onloadend = () => {
                    if (reader.result && reader.result instanceof ArrayBuffer) {
                        const bytes = new Uint8Array(reader.result);
                        const hex = Array.from(bytes).map(b => b.toString(16).padStart(2, '0').toUpperCase());
                        resolve(hex);
                    } else {
                        reject(new Error('Failed to read file as ArrayBuffer.'));
                    }
                };
                reader.onerror = reject;
            });
        };

        const allowedSignatures = {
            'FF D8 FF E0': ['jpg', 'jpeg', 'jpe', 'jif', 'jfif'],
            '89 50 4E 47': ['png'],
            '47 49 46 38': ['gif'],
            '25 50 44 46': ['pdf'],
            '50 4B 03 04': ['zip', 'docx', 'xlsx', 'pptx', 'ppsx'],
            '52 61 72 21': ['rar'],
            '49 44 33': ['mp3'],
            '255 251': ['mp3'],
            '30 26 B2 75': ['wma'],
            '46 4C 56': ['flv'],
            '52 49 46 46': ['avi', 'wav', 'webp'],
            '00 00 00 18 66 74 79 70': ['mp4', 'm4v', 'm4a', 'mov'],
            '66 74 79 70': ['mp4', 'm4v', 'm4a', 'mov'],
            'D0 CF 11 E0': ['doc', 'xls', 'ppt'],
            '7B 5C 72 74 66': ['rtf'],
            '3C 73 76 67': ['svg'],
            '3C 3F 78 6D 6C': ['xml'],
        };
        const inputFiles = Array.isArray(files) ? files : [files];
        for (let i = 0; i < inputFiles.length; i++) {
            const file = inputFiles[i];
            const hexArray = await getFileSignature(file);
            const joined = hexArray.join(' ');
            const shortHex = hexArray.slice(0, 4).join(' ');

            let matched = false;
            for (const sig in allowedSignatures) {
                if (joined.startsWith(sig) || shortHex.startsWith(sig)) {
                    matched = true;
                    break;
                }
            }

            if (!matched) {
                return false;
            }
        }
        return true;
    }

}
export default new aclHelper();